export default __webpack_public_path__ + "static/media/sendex-logo.3048fbe9.png";